/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2LedgerFilterClaims/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2LedgerFilterClaims({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2LedgerFilterClaims",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 13,
  height = 13,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  stroke = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2LedgerFilterClaims.Svg"
  data-view-path={viewPath}
 viewBox="0 0 13 13"
 style={{'--as-1-Zvib7f': alignSelf,'--mt-2-Zvib7f': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Zvib7f': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Zvib7f': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Zvib7f': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Zvib7f': opacity,'--w-10-Zvib7f': typeof width === 'number' ? `${width}px` : width,'--h-11-Zvib7f': typeof height === 'number' ? `${height}px` : height,'--f-12-Zvib7f': fill,'--a-7-Zvib7f': isAnimated ? animation : "none",'--sd-8-Zvib7f': isAnimated ? strokeDashoffset : 0,'--sd-9-Zvib7f': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2LedgerFilterClaims.SvgPath"
  data-view-path={viewPath}
 d="M10.654.5H2.346C1.326.5.5 1.327.5 2.346v8.308c0 1.02.827 1.846 1.846 1.846h8.308c1.02 0 1.846-.826 1.846-1.846V2.346C12.5 1.326 11.674.5 10.654.5zM6.5.5v12M.5 6.5h12M2.345 3.5h2.307M8.576 3.5h1.846M8.576 8.577h1.846M8.576 10.423h1.846M3.5 2.346v2.308M2.522 8.521l1.957 1.957M4.48 8.521l-1.958 1.957"
 strokeLinecap="round"
 strokeLinejoin="round"
 style={{'--s-13-Zvib7f': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}